import { DownloadFileAPI } from '../../../api/files/DownloadFileAPI';

export class DownloadCommand {
    constructor() {
        this.downloadFileApi = new DownloadFileAPI();
    }

    downloadSpiderMap(name, successCallback, errorCallback) {
        const apiResult = this.downloadFileApi.downloadSpiderMap(name);
        apiResult.then(async (result) => {
            if (undefined !== successCallback) {
                successCallback(await result.blob(), name);
            }
        }).catch((ex) => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a transferir o ficheiro.");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/spidermap/commands/DownloadCommand.js